import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const pathname = location.pathname || '';

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl">Duke ngarkuar...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles.length > 0 && !requiredRoles.includes(user.role)) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl text-red-600">Nuk keni qasje në këtë faqe</div>
      </div>
    );
  }

  // Nëse përdoruesi ka allowed_routes, lejo vetëm ato rrugë; përndryshe ridrejto te e para e lejuar ose dashboard.
  const allowedPaths = user.allowed_routes && Array.isArray(user.allowed_routes) && user.allowed_routes.length > 0
    ? user.allowed_routes
    : null;
  if (allowedPaths !== null) {
    // /me është faqja e profilit (Unë) në mobil; nuk është në checklist të adminit, por duhet gjithmonë e hapur.
    if (pathname === '/me') {
      return children;
    }
    const exactMatch = allowedPaths.includes(pathname);
    const prefixMatch = allowedPaths.some((p) => pathname.startsWith(p + '/') || pathname === p);
    if (!exactMatch && !prefixMatch) {
      const first = allowedPaths[0] || '/dashboard';
      return <Navigate to={first} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
